var map = {
	"./ambassador-bg.webp": 1271,
	"./asset-2.png": 1272,
	"./btn-enter-bg.png": 1273,
	"./btn-enter-white-bg.webp": 1274,
	"./btn-more-bg.webp": 1275,
	"./casino-hover.webp": 1276,
	"./casino.webp": 1277,
	"./convenient.webp": 1278,
	"./es-bg.webp": 1279,
	"./event-sec-bg.webp": 1280,
	"./event-sport-bg.webp": 1281,
	"./fifa1-bg.jpg": 1282,
	"./fifa2-bg-cn.jpg": 1283,
	"./fifa2-bg.jpg": 1284,
	"./games-hover.webp": 1285,
	"./games.webp": 1286,
	"./gauge.webp": 1287,
	"./lottery-hover.webp": 1288,
	"./lottery.webp": 1289,
	"./master-bg.webp": 1290,
	"./p2p-hover.webp": 1291,
	"./p2p.webp": 1292,
	"./platform.webp": 1293,
	"./product-ctg-bg.webp": 1294,
	"./product-overview-bg.webp": 1295,
	"./professional.webp": 1296,
	"./safety.webp": 1297,
	"./slots-hover.webp": 1298,
	"./slots.webp": 1299,
	"./speed.webp": 1300,
	"./sports-hover.webp": 1301,
	"./sports.webp": 1302,
	"./video-bg.webp": 1303,
	"./wave.webp": 1304,
	"./wwr-bg.webp": 1305,
	"./wwr-img-b.webp": 1306,
	"./wwr-img.webp": 1307,
	"./wwr-subImg1.webp": 1308,
	"./wwr-subImg2.webp": 1309,
	"./wwr-subImg3.webp": 1310,
	"./x33-logo-cny.png": 1311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 461;